import { render, staticRenderFns } from "./SelectWizardWhoSelectDoctor.vue?vue&type=template&id=42db4b83&scoped=true&"
import script from "./SelectWizardWhoSelectDoctor.vue?vue&type=script&lang=js&"
export * from "./SelectWizardWhoSelectDoctor.vue?vue&type=script&lang=js&"
import style0 from "./SelectWizardWhoSelectDoctor.vue?vue&type=style&index=0&id=42db4b83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42db4b83",
  null
  
)

export default component.exports